var render, staticRenderFns
import script from "./pill-badge.vue?vue&type=script&lang=js"
export * from "./pill-badge.vue?vue&type=script&lang=js"
import style0 from "./pill-badge.vue?vue&type=style&index=0&id=a9250376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9250376",
  null
  
)

export default component.exports